import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M168.941176,-0.0112941176 L168.941176,1919.98871 L56,1919.98871 L56,-0.0112941176 L168.941176,-0.0112941176 Z M281.882353,68.4423529 C590.550588,-13.2141176 778.032941,94.8705882 959.077647,201.487059 C1162.48471,321.430588 1372.66824,445.552941 1792.92235,340.517647 C1813.13882,335.548235 1834.59765,341.985882 1848.71529,357.684706 C1862.60706,373.383529 1866.78588,395.52 1859.55765,415.171765 C1656.15059,957.515294 1355.38824,967.905882 1064.56471,977.957647 C841.28,985.863529 610.315294,993.769412 378.221176,1225.86353 L378.221176,1225.86353 L281.882353,1322.20235 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconFlagSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconFlagSolid, _Component);

  var _super = _createSuper(IconFlagSolid);

  function IconFlagSolid() {
    _classCallCheck(this, IconFlagSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconFlagSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconFlag",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconFlagSolid.displayName = "IconFlagSolid";
  return IconFlagSolid;
}(Component);

IconFlagSolid.glyphName = 'flag';
IconFlagSolid.variant = 'Solid';
IconFlagSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconFlagSolid;
export { IconFlagSolid };